import { render } from "./MathsHomeView.vue?vue&type=template&id=c31d5cbc&ts=true"
import script from "./MathsHomeView.vue?vue&type=script&lang=ts"
export * from "./MathsHomeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__